import { createRouter, createWebHistory } from 'vue-router'
import { auth } from './firebase'
import { signOut, onAuthStateChanged } from 'firebase/auth'
import { getUserRole } from './services/userRole'
import Login from './components/Login.vue'
import Dashboard from './components/Dashboard.vue'
import Users from './components/Users.vue'
import Churches from './components/Churches.vue'
import Categories from './components/Categories.vue'
import Chat from './components/Chat.vue'
import DataDeletionRequest from './components/DataDeletionRequest.vue'
// ConfirmDeletion component removed - no longer needed

const routes = [
  {
    path: '/',
    redirect: () => {
      // This will be handled by the navigation guard
      return '/dashboard'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/delete-user',
    name: 'DataDeletionRequest',
    component: DataDeletionRequest,
    meta: { requiresAuth: true }
  },
  // ConfirmDeletion route removed - no longer needed
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/churches',
    name: 'Churches',
    component: Churches,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/categories',
    name: 'Categories',
    component: Categories,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/chat/:categoryId?',
    name: 'Chat',
    component: Chat,
    meta: { requiresAuth: true, requiresAdmin: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Function to get current user with promise
function getCurrentUser() {
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      unsubscribe()
      resolve(user)
    }, reject)
  })
}

// Navigation guard
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
  
  try {
    // Wait for authentication state to be determined
    const currentUser = await getCurrentUser()

    if (requiresAuth && !currentUser) {
      next('/login')
    } else if (to.path === '/login' && currentUser) {
      // Check if user is admin before redirecting to dashboard
      if (requiresAdmin) {
        const userRole = await getUserRole(currentUser.email)
        if (userRole !== 1) {
          // Sign out the user and stay on login
          await signOut(auth)
          next({ path: '/login', query: { error: 'access_denied' } })
          return
        }
      }
      next('/dashboard')
    } else if (requiresAdmin && currentUser) {
      // Check admin role for protected routes
      const userRole = await getUserRole(currentUser.email)
      if (userRole !== 1) {
        // Sign out the user and redirect to login with error
        await signOut(auth)
        next({ path: '/login', query: { error: 'access_denied' } })
      } else {
        next()
      }
    } else {
      next()
    }
  } catch (error) {
    console.error('Navigation guard error:', error)
    next('/login')
  }
})

export default router
